import "../../../styles/input.scss";

import Icon, {iconTypes} from "./Icon.jsx";
import React, {Component} from "react";

import LabelField from "./LabelField";
import PropTypes from "prop-types";

export default class CheckBox extends Component {
    constructor(props){
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        const {
            property,
            onChange,
            source
        } = this.props;
        onChange({
            [property]: !source[property],
        });
    }

    render() {
        const {
            className,
            disabled,
            label,
            source,
            property,
        } = this.props;

        return (
            <React.Fragment>
                <div className={`input-radio ${className}`} style={{opacity:disabled?"0.5":undefined}}>
                    <div className={"box"} onClick={disabled?undefined:this.onClick}>
                        <Icon type={source[property] ? iconTypes.checkboxChecked : iconTypes.checkbox} />
                    </div>
                    <LabelField label={label}/>
                </div>
            </React.Fragment>
        );
    }
}

CheckBox.propTypes = {
    //
    // Mandatory
    //
    // called when finished editing input field
    property: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.arrayOf(PropTypes.string.isRequired)]).isRequired,
    source: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    //
    // Optional
    //
    disabled: PropTypes.bool,
    className: PropTypes.string,
};

CheckBox.defaultProps = {
    disabled: false,
};